import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Cookies from 'js-cookie'
import { setTabId, setMultipleTabs } from 'store/actions/global'
import { v4 as uuidv4 } from 'uuid'
import { TabIdCookieName } from 'common/Enums'
import { store } from 'store'

export const isCurrentTabPrime = () => {
    const tabId = Cookies.get(TabIdCookieName)
    const uuid = store.getState().global.tabId
    return tabId === uuid || !tabId
}

export const setCurrentTabPrime = () => {
    Cookies.set(TabIdCookieName, store.getState().global.tabId)
    store.dispatch(setMultipleTabs(false))
    addTabListeners()
}

export const checkMultiTabsOpen = () => {
    isCurrentTabPrime() ? setCurrentTabPrime() : store.dispatch(setMultipleTabs(true))
}

export const isAnotherActiveTab = () => !isCurrentTabPrime()

const removeTabId = () => Cookies.remove(TabIdCookieName)

const addTabListeners = () => {
    window.addEventListener('beforeunload', removeTabId)
    window.addEventListener('unload', () => removeTabId)
}

export const cleanupTabListeners = () => {
    window.removeEventListener('beforeunload', removeTabId)
    window.removeEventListener('unload', () => removeTabId)
}

export const useUniqueTab = ({ isUserAuthed }) => {
    const dispatch = useDispatch()
    const { isInternetConnectionLost, tabId } = useSelector((state) => state.global)

    // Generates unique tab identifier
    useEffect(() => {
        if (isUserAuthed && !isInternetConnectionLost) {
            dispatch(setTabId(uuidv4()))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserAuthed])

    // Avoids app to be load in multiple tabs
    useEffect(() => {
        checkMultiTabsOpen()
    }, [tabId])
}
